export const realtime = {
	en: {
		title: 'GS Trackme Platform v3',
		nav: {
			historical: 'History',
			reports: 'Reports',
			geofences: 'Geofences',
			maintenance: 'Maintenance',
			users: "Users",
			administration: 'Admin',
			routes: 'Routes',
			cameras: 'Cameras',
			realtime: {
				title: 'Map View',
				styles: [
					{ value: 0, text: 'GS TrackMe' },
					{ value: 1, text: 'Google view' },
					{ value: 2, text: 'Terrain' },
					{ value: 3, text: 'Satellite' },
					{ value: 4, text: 'Hybrid' },
					{ value: 5, text: '45º view' }
				]
			},
			logout: 'Logout',
			circular: {
				events: 'Events panel',
				geofences: 'Show/hide geofences',
				pois: 'Show/hide POIs',
				clusters: 'Enable/disable clusters',
				groups: 'See groups',
				audios: 'See audios',
			},
			executive: 'Executive Reports',
			testing: 'Beta'
		},
		select: {
			title: 'PANORAMIC VIEW',
			subtitle: 'LIST OF VEHICLES',
			none: 'NONE'
		},
		info: {
			speed: 'SPEED',
			odometer: 'DAILY TRIP',
			unities: ['MPH', 'Mi']
		},
		groups: {
			devices: 'Devices',
			groups: 'Groups',
			apply: 'Apply',
		},
		search: {
			placeholder: 'Find the vehicle closest to...',
			radios: ['All', 'Establishments', 'Address']
		},
		alarms: {
			title: 'SELECT A DEVICE TO SEE YOUR ALERTS',
			noalarms: "NO EVENTS TRIGGERED",
			icons: [
				{ code: '001', label: 'SOS button', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '002', label: 'Engine ignition', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '003', label: 'Engine shutdown', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '004', label: 'Open door', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '006', label: 'GPS Unplugged', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '007', label: 'Low battery', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '015', label: 'Gasoline increase', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '016', label: 'Gasoline decrease', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '019', label: 'Sweeper', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '021', label: 'PTO', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '025', label: 'Idle', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '026', label: 'Revolutions per minute', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '027', label: 'Acceleration', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '028', label: 'Deceleration', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '030', label: 'Stop', vshow: true, active: true, quantity: 0, group: 2 },
				{ code: '032', label: 'Speeding', vshow: true, active: true, quantity: 0, group: 3 },
				{ code: '033', label: 'Posted Speed', vshow: true, active: true, quantity: 0, group: 3 },
				{ code: '035', label: 'Entry to geofence', vshow: true, active: true, quantity: 0, group: 4 },
				{ code: '036', label: 'Geofence exit', vshow: true, active: true, quantity: 0, group: 4 },
				{ code: '037', label: 'Minimum time in point unfulfilled', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '038', label: 'Maximum time in point exceeded', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '050', label: 'WiFi connection', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '051', label: 'Data connection', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '054', label: 'Check in', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '055', label: 'Check out', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '060', label: 'Start of route', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '061', label: 'End of route', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '062', label: 'Route deviation', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '070', label: 'Temperature decrease', vshow: true, active: true, quantity: 0, group: 5 },
				{ code: '071', label: 'Temperature increase', vshow: true, active: true, quantity: 0, group: 5 },
				{ code: '080', label: 'Connected call', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '081', label: 'Canceled call', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '082', label: 'Ended call', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '200', label: 'Sharp turn left', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '201', label: 'Sharp turn right', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '300', label: 'Collision', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '400', label: 'Jamming detected', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '090', label: 'Padlock cable cut', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '091', label: 'Padlock locked', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '092', label: 'Padlock unlocked', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '093', label: 'Padlock wrong password', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '992', label: 'GPS Signal recovered', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '997', label: 'Check engine light', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '999', label: 'GPS Signal loss', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1000', label: 'Video Loss', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1001', label: 'Lens Covered', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1002', label: 'Storage Malfunction', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1003', label: 'Harsh Brake', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1004', label: 'Harsh Right Turn', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1005', label: 'Harsh Left Turn', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1006', label: 'IO1', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1007', label: 'IO2', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1008', label: 'IO3', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1009', label: 'IO4', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1010', label: 'Driver Fatigue', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1011', label: 'No Driver', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1012', label: 'Phone Calling', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1013', label: 'Driver Smoking', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1014', label: 'Driver Distracted', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1015', label: 'Lane departure warning LDW', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1016', label: 'Forward Collision Warning FCW', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1017', label: 'Headway Monitoring HMW', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1018', label: 'Yawn', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1019', label: 'Pedestrian Collision Warning PCW', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1020', label: 'Not wearing seatbelt', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1021', label: 'Stop sign violation alarm', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1022', label: 'Speed limit sign violation alarm', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1023', label: 'Power failure alarm', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1024', label: 'Shock', vshow: true, active: true, quantity: 0, group: 1 },
			],
			info: {
				start: 'Start',
				stop: 'Stop',
				idle: 'Idle',
				duration: 'Duration',
				speed: 'Speed',
				postedSpeed: 'Posted Speed',
				percentD: 'Percent Decrease',
				percentI: 'Percent Increase'
			}
		},
		actions: {
			title: '',
			icons: [
				{ code: 'hide', label: 'Show/Hide vehicle', selected: true },
				{ code: 'center', label: 'Center vehicle', selected: false },
				{ code: 'history', label: 'Show/Hide history', selected: false },
				{ code: 'route', label: 'Show/hide routes', selected: false },
				{ code: 'street-view', label: 'Refresh Street View', selected: false },
			],
			go_v4: "Go to V4",
			link_v4: "https://gstrackme.net/v4/"
		},
		errors: {
			alarms: 'Error retrieving alarms',
			center: 'You must have a device selected to be able to center it',
			before: 'You must have selected a device to show your route',
		},
		infowindow: {
			titles: {
				general: 'GENERAL',
				details: 'DETAILS',
				admin: 'ADMIN',
				technical: 'Technical details',
				clientDet: 'Client details',
				drivers: 'DRIVERS'
			},
			subtitles: {
				status: ['WITHOUT SIGNAL', 'STOPPED', 'IDLING', 'IN MOVEMENT', 'WITHOUT GPS SIGNAL', 'IN SLEEP MODE', 'WITH ENGINE STOP COMMAND', 'SLEEP MODE / NO GPS', 'NO ENERGY SOURCE', 'GPS LOW BATTERY'],
				diff: ['DAYS', 'HOURS', 'MINUTES', 'SECONDS'],
				brand: 'Brand',
				make: 'Make',
				model: 'Model',
				year: 'Year',
				// speedLimit: 'Posted Speed',
				speedLimit: 'Speed Treshold',
				street: 'Street',
				gas: 'Gasoline',
				// postSpeed: 'Speed Limit',
				postSpeed: 'Posted Speed',
				plates: 'Plates',
				mileage: 'Speed',
				quickActions: 'Quick Actions',
				businessName: 'BUSINESS NAME',
				imei: 'IMEI',
				phone: 'PHONE',
				port: 'DEVICE PORT',
				device: 'DEVICE',
				alias: 'ALIAS',
				contact: 'CONTACT',
				user: 'USER',
				movil: 'MOBILE',
				city: 'CITY',
				last: 'Today | Yesterday | {date}',
				coords: 'Coordinates'
			},
			battery_status: {
				1: 'Good',
				2: 'Low',
				3: 'Bad/Replace'
			}
		},
		orientation: {
			n: 'TO THE NORTH AT',
			ne: 'TO THE NORTHEAST AT',
			nw: 'TO THE NORTHWEST AT',
			e: 'TO THE EAST AT',
			w: 'TO THE WEST AT',
			se: 'TO THE SOUTHEAST AT',
			sw: 'TO THE SOUTHWEST AT',
			s: 'TO THE SOUTH AT',
			ng: 'A'
		},
		modals: {
			actions: ['Close'],
			events: {
				title: "Events table",
				tabs: ['Idling', 'Stops', 'GPS Unplugged', 'Speeding', 'PTO'],
				columns: ['Type', 'Duration', 'Time', 'Start time'],
				types: ['Idling', 'Stop', 'GPS Unplugged ', ' Speeding', 'PTO'],
				stopTypes: ['Normal', 'Moderate', 'Exceeded']
			},
			accounts: {
				title: 'AVAILABLE ACCOUNTS',
				allDevices: 'See all devices.'
			},
		},
		findme: {
			expired: 'The token has expired.'
		},
		notifications: {
			geofences: ['Geofences loaded successfully.', 'Without geofences.', 'An error has occurred.'],
			pois: ['POIS loaded successfully.', 'Without POIS.', 'An error has occurred.'],
			devices: ['Successfully {count} devices loaded', 'Without assigned devices'],
			routes: ['Routes loaded successfully.', 'Without Routes.', 'An error has occurred.'],
			drivers: ['Drives loaded successfully.', 'Without Drivers.', 'An error has occurred.'],
			camera: ['Connecting to the camera, wait for a moment','Successful connection, waiting for multimedia content','Connection failed, try again later','There is already a pending request for this device, please wait','Download data exceeded.','Camera is On','Camera is Off'],
			cluster: ['Cannot be grouped with a device, this action only is allow with more one device'],
		}
	},
	es: {
		title: 'GS Trackme Plataforma v3',
		nav: {
			historical: 'Historico',
			reports: 'Reportes',
			geofences: 'Geocercas',
			maintenance: 'Mantenimiento',
			users: "Usuarios",
			administration: 'Administración',
			routes: 'Rutas',
			cameras: 'Cámaras',
			realtime: {
				title: 'Vista del mapa',
				styles: [
					{ value: 0, text: 'GS TrackMe' },
					{ value: 1, text: 'Vista Google' },
					{ value: 2, text: 'Terreno' },
					{ value: 3, text: 'Satélite' },
					{ value: 4, text: 'Híbrido' },
					{ value: 5, text: 'Vista 45º' }
				]
			},
			logout: 'Cerrar sessión',
			circular: {
				events: 'Panel de eventos',
				geofences: 'Mostrar/ocultar geocercas',
				pois: 'Mostrar/ocultar POIs',
				clusters: 'Activar/desactivar clústeres',
				groups: 'Ver grupos',
				audios: 'Ver audios',
			},
			executive: 'Reportes Ejecutivos',
			testing: 'Beta'
		},
		select: {
			title: 'VISTA PANORÁMICA',
			subtitle: 'LISTA DE VEHÍCULOS',
			none: 'NINGUNO'
		},
		info: {
			speed: 'VELOCIDAD',
			odometer: 'ODÓMETRO',
			unities: ['KM/H', 'KM']
		},
		groups: {
			devices: 'Dispositivos',
			groups: 'Grupos',
			apply: 'Aplicar',
		},
		search: {
			placeholder: 'Encontrar el vehículo más cercano a...',
			radios: ['Todos', 'Establecimientos', 'Dirección']
		},
		alarms: {
			title: 'SELECCIONE UN DISPOSITIVO PARA VER SUS ALERTAS',
			noalarms: 'SIN EVENTOS GENERADOS',
			icons: [
				{ code: '001', label: 'Botón de pánico', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '002', label: 'Encendido de motor', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '003', label: 'Apagado de motor', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '004', label: 'Puerta abierta', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '006', label: 'Desconexión de GPS', vshotruew: true, active: true, quantity: 0, group: 1 },
				{ code: '007', label: 'Batería baja', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '015', label: 'Incremento de gasolina', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '016', label: 'Decremento de gasolina', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '019', label: 'Barredora', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '021', label: 'Grúa', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '025', label: 'Inactivo', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '026', label: 'Revoluciones por minuto', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '027', label: 'Aceleración', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '028', label: 'Desaceleración', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '030', label: 'Parada', vshow: true, active: true, quantity: 0, group: 2 },
				{ code: '032', label: 'Exceso de velocidad', vshow: true, active: true, quantity: 0, group: 3 },
				{ code: '033', label: 'Limite de Calle Excedido', vshow: true, active: true, quantity: 0, group: 3 },
				{ code: '035', label: 'Entrada a geocerca', vshow: true, active: true, quantity: 0, group: 4 },
				{ code: '036', label: 'Salida de geocerca', vshow: true, active: true, quantity: 0, group: 4 },
				{ code: '037', label: 'Tiempo mínimo en punto incumplido', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '038', label: 'Tiempo máximo en punto excedido', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '050', label: 'Conexión Wifi', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '051', label: 'Conexión de datos', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '054', label: 'Entrada', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '055', label: 'Salida', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '060', label: 'Inicio de ruta', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '061', label: 'Finalización de ruta', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '062', label: 'Desvio de ruta', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '070', label: 'Decremento de temperatura', vshow: true, active: true, quantity: 0, group: 5 },
				{ code: '071', label: 'Incremento de temperatura', vshow: true, active: true, quantity: 0, group: 5 },
				{ code: '080', label: 'Llamada establecida', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '081', label: 'Llamada cancelada', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '082', label: 'Llamada finalizada', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '200', label: 'Giro brusco a la izquierda', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '201', label: 'Giro brusco a la derecha', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '300', label: 'Colisión', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '400', label: 'Jamming detectado', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '090', label: 'Cable de candado cortado', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '091', label: 'Candado cerrado', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '092', label: 'Candado desbloqueado', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '093', label: 'Contraseña incorrecta del candado', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '992', label: 'Señal de GPS recuperada', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '997', label: 'Error de Motor', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '999', label: 'Perdida de Señal GPS', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1000', label: 'Pérdida de Vídeo', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1001', label: 'Lente Tapado', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1002', label: 'Fallo de Almacenamiento', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1003', label: 'Freno Brusco', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1004', label: 'Giro Brusco a la Derecha', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1005', label: 'Giro Brusco a la Izquierda', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1006', label: 'IO1', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1007', label: 'IO2', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1008', label: 'IO3', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1009', label: 'IO4', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1010', label: 'Fatiga del Conductor', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1011', label: 'Sin Conductor', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1012', label: 'Llamada telefónica', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1013', label: 'Conductor Fumando', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1014', label: 'Conductor Distraído', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1015', label: 'Aviso de Salida de Carril LDW', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1016', label: 'Aviso de Colisión Frontal FCW', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1017', label: 'Cercanía de vehículo HMW', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1018', label: 'Bostezo', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1019', label: 'Aviso de Colisión con Peatones PCW', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1020', label: 'Sin Cinturón de Seguridad', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1021', label: 'Violación de Señal de Stop', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1022', label: 'Violación de Señal de Límite de Velocidad', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1023', label: 'Fallo de Alimentación', vshow: true, active: true, quantity: 0, group: 1 },
				{ code: '1024', label: 'Shock', vshow: true, active: true, quantity: 0, group: 1 },
			],
			info: {
				start: 'Inicio',
				stop: 'Inicio',
				idle: 'Inicio',
				duration: 'Duración',
				speed: 'Velocidad',
				postedSpeed: 'Velocidad Pública',
				percentD: 'Porcentaje de Decremento',
				percentI: 'Porcentaje de Incremento'
			}
		},
		actions: {
			title: '',
			icons: [
				{ code: 'hide', label: 'Mostrar/Ocultar vehículo', selected: true },
				{ code: 'center', label: 'Centrar vehículo', selected: false },
				{ code: 'history', label: 'Mostrar/Ocultar histórico', selected: false },
				{ code: 'route', label: 'Mostrar/ocultar rutas', selected: false },
				{ code: 'street-view', label: 'Actualizar Street View', selected: false },
			],
			go_v4: "Ir a V4",
			link_v4: "https://gstrackme.mx/login?lang=es"
		},
		errors: {
			alarms: 'Error al recuperar las alarmas',
			center: 'Debe tener seleccionado un dispositivo para poder centrarlo',
			before: 'Debe tener seleccionado un dispositivo para poder mostrar su recorrido'
		},
		infowindow: {
			titles: {
				general: 'GENERAL',
				details: 'DETALLES',
				admin: 'ADMIN',
				technical: 'Detalles Técnicos',
				clientDet: 'Detalles del Cliente',
				drivers: 'CONDUCTORES'
			},
			subtitles: {
				status: ['SIN SEÑAL', 'DETENIDO', 'ESTACIONADO', 'EN MOVIMIENTO', 'SIN SEÑAL GPS', 'EN AHORRO DE ENERGÍA', 'CON COMANDO DE PARO DE MOTOR', 'AHORRO DE ENERGÍA / SIN SEÑAL GPS', 'SIN FUENTE DE ENERGÍA', 'GPS BATERÍA BAJA'],
				diff: ['DÍAS', 'HORAS', 'MINUTOS', 'SEGUNDOS'],
				brand: 'Dispositivo',
				make: 'Marca',
				model: 'Modelo',
				year: 'Año',
				speedLimit: 'Límite de Vel.',
				street: 'Calle',
				gas: 'Gasolina',
				postSpeed: 'Límite en Calle',
				plates: 'Placas',
				mileage: 'Kilometraje',
				quickActions: 'Acciones Rápidas',
				businessName: 'NOMBRE EMPRESARIAL',
				imei: 'IMEI',
				phone: 'TELÉFONO',
				port: 'PUERTO',
				device: 'DISPOSITIVO',
				alias: 'ALIAS',
				contact: 'CONTACTO',
				user: 'USUARIO',
				movil: 'MÓVIL',
				city: 'CIUDAD',
				last: 'Hoy | Ayer | {date}',
				coords: 'Coordenadas'
			},
			battery_status: {
				1: 'Bueno',
				2: 'Bajo',
				3: 'Malo/Reemplazo'
			}
		},
		orientation: {
			n: 'HACIA EL NORTE A',
			ne: 'HACIA EL NORESTE A',
			nw: 'HACIA EL NOROESTE A',
			e: 'HACIA EL ESTE A',
			w: 'HACIA EL OESTE A',
			se: 'HACIA EL SURESTE A',
			sw: 'HACIA EL SUROESTE A',
			s: 'HACIA EL SUR',
			ng: 'A'
		},
		modals: {
			actions: ['Cerrar'],
			events: {
				title: 'Tabla de Eventos',
				tabs: ['Inactividad', 'Paradas', 'Desconexión de GPS', 'Exceso de velocidad', 'Botón de Pánico'],
				columns: ['Tipo', 'Duración', 'Hora', 'Hora de Inicio'],
				types: ['Inactividad', 'Parada', 'GPS desconectado', 'Exceso de Velocidad', 'Botón de Pánico'],
				stopTypes: ['Normal', 'Moderada', 'Excedida']
			},
			accounts: {
				title: 'CUENTAS DISPONIBLES',
				allDevices: 'Ver todos los dispositivos.'
			},
		},
		findme: {
			expired: 'El token ha expirado.'
		},
		notifications: {
			geofences: ['Geocercas cargadas correctamente.', 'Sin geocercas.', 'Un error ha ocurrido.'],
			pois: ['POIS cargados correctamente.', 'Sin POIS.', 'Un error ha ocurrido.'],
			devices: ['{count} dispositivos cargados con éxito', 'Sin dispositivos asignados'],
			routes: ['Rutas cargadas correctamente.', 'Sin Rutas asignadas.', 'Un error ha ocurrido.'],
			drivers: ['Conductores cargadas correctamente.', 'Sin conductores asignados.', 'Un error ha ocurrido.'],
			camera: ['Conectando con la cámara, espere un momento','Conexión exitosa, esperando el contenido multimedia','Conexión fallida, intente más tarde','Ya existe una petición pendiente para este dispositivo, espere por favor','Datos de descarga excedidos.','Cámara Encendida','Cámara Apagada'],
			cluster: ['No puede ser agrupado con un dispositivo, esta acción solo está disponible con más de un dispositivo'],
		}
	}
}
